import type { GetServerSidePropsContext, NextPage } from 'next';

import { MembersApiService, WebAppApiService } from 'services';
import { IMemberModel, IWebAppModel } from 'models';

import MemberCard from '@/components/member/member-card';

import Layout from '@/components/layout/layout';
import { PagesType } from 'common/pages-type';

import styles from './members.module.scss';
import { useEffect } from 'react';
import { MixpanelTrackingService } from '@/services/mixpanel-services';

interface IMembersPageProps {
  webApp: IWebAppModel;
  members: IMemberModel[];
  preview: boolean;
}

const MembersPage: NextPage<IMembersPageProps> = ({
  webApp,
  members,
  preview,
}) => {
  useEffect(() => {
    MixpanelTrackingService.getInstance().pageViewed();
  }, []);

  return (
    <Layout
      preview={preview}
      origin={PagesType.Members}
      headerImageUrl={webApp.headerImageUrl}
      logoUrl={webApp.logoUrl}
      stravaUrl={webApp.stravaUrl}
      facebookUrl={webApp.facebookUrl}
      instagramUrl={webApp.instagramUrl}
      title={webApp.siteName}
      description={webApp.description}>
      <div className={styles.container}>
        <h1 className={styles.title}>Nos membres</h1>

        <div className={styles.members}>
          {members.map((m) => (
            <a key={m.id} href={`members/${m.pseudo}`}>
              <MemberCard key={m.id} member={m} />
            </a>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  try {
    const webAppService = new WebAppApiService();
    const webapp = await webAppService.getWebApp(context);

    const service = new MembersApiService();
    const members = await service.getAllMembers(context, context.preview);

    return {
      props: {
        webApp: webapp,
        members: members,
        preview: context.preview ?? false,
      } as IMembersPageProps,
    };
  } catch {
    return {
      props: {},
    };
  }
};

export default MembersPage;
